import { apiProxyRequest } from "Api/apiProxyRequest";
import { ProfileDetail, ProfileDetailCreatableFields } from "../types";

export const createBillingProfileDetail = (
  billingAccountId: string,
  payload: ProfileDetailCreatableFields
) => {
  return apiProxyRequest<ProfileDetail>(
    `/billing/accounts/${billingAccountId}/profiles`,
    "POST",
    payload
  );
};
